module.exports = __webpack_public_path__ + "img/collection-memoireRingsRingsets@2x.95f49fb.jpg";